import request from '@/utils/request';
import defaultRequest from '@/utils/defaultRequest';

// 登录
export default {
  validateTenantId: code =>
    request('/oauth2/oauth/verify/tenant', {
      method: 'get',
      headers: {
        tenant_id: encodeURIComponent(code),
      },
    }),
  iconTitle: code =>
    request('/oauth2/oauth/detail/tenant', {
      method: 'get',
      headers: {
        tenant_id: encodeURIComponent(code),
      },
    }),
  login: data =>
    defaultRequest('/oauth2/oauth/token', {
      params: {
        username: data.username,
        password: data.password,
        grant_type: data.grant_type,
        client_id: data.client_id,
        client_secret: data.client_secret,
      },
      method: 'post',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }),
  // 切换代理人
  switchToProxy: data =>
    request(`/oauth2/proxy/get/token?user_id=${data.user_id}`, {
      method: 'get',
    }),
  // 恢复本人
  switchToSelf: data =>
    request(`/oauth2/proxy/reverse?user_id=${data}`, {
      method: 'get',
    }),
  // 远程查询user
  searchStaffUser: data =>
    request(`/ess/user/q/users/${data.page}/${data.per_page}`, {
      params: { name: data.name },
      method: 'get',
    }),
  // 查询可做代理的人
  searchProxyUser: data =>
    request(`/ess/user/q/proxyUsers/${data.page}/${data.per_page}`, {
      params: { name: data.name },
      method: 'get',
    }),
  // 获取代理人列表
  getProxyList: () =>
    request('/ess/user/proxy/origin/list', {
      method: 'get',
    }),
  loginOut: data =>
    fetch(`${process.env.VUE_APP_REQUEST_BASE_URL}/oauth2/oauth/revokeUserToken/${data}`, {
      method: 'get',
      headers: sessionStorage.getItem('access_token')
        ? {
            Authorization: sessionStorage.getItem('access_token'),
            tenant_id: localStorage.getItem('tenantId'),
          }
        : { tenant_id: localStorage.getItem('tenantId') },
    })
      .then(res => res.json())
      .then(res => res),
  getVerifyImg: () =>
    request('/captcha/img/refresh/290/130', {
      method: 'get',
    }),
  validateImg: data =>
    defaultRequest(`/captcha/img/verify/${data.key}/${data.distance}`, {
      method: 'get',
    }),
  getUserInfo: () =>
    request('/ess/user/info', {
      method: 'get',
    }),
  getUserApplication: () =>
    request('/oauth2/privilege/home/menu', {
      method: 'get',
    }),
  getUserMenu: () =>
    request('/oauth2/privilege/menu', {
      method: 'get',
    }),
  // 获取可跳转路由
  getUserRouter: data =>
    request('/oauth2/privilege/auth/route', {
      method: 'get',
      headers: {
        menu_id: data,
      },
    }),
  // 设置我的应用
  setUserApplication: data =>
    request('/ess/user/reset/home/menu', {
      method: 'post',
      body: data,
    }),
  // 修改用户邮箱
  modifyUserEmail: data =>
    request(`/ess/user/set/email/${data.email}`, {
      method: 'post',
    }),
  deleteToken: data =>
    request(`/oauth2/oauth/cancel/${data.tenantId}/${data.token}`, {
      method: 'get',
    }),
  // 修改密码
  modifyPassword: data =>
    request(`/ess/user/reset/password/${data}`, {
      method: 'POST',
    }),
  // 同意用户协议
  acceptTerm: () =>
    request('/ess/user/accept/term', {
      method: 'PUT',
    }),
  // 容联七陌单点登陆
  onpointLogin: data =>
    fetch(`https://apis.7moor.com/v20160818/sso/getToken/N00000040220?sig=${data.sigS}`, {
      method: 'post',
      body: data.form,
      headers: {
        'content-Type': 'application/json;charset=utf-8',
        Authorization: data.Auth,
      },
    })
      .then(res => res.json())
      .then(res => res),
  // candidate
  getAccessToken: data =>
    request('/oauth2/ob/access/token', {
      method: 'post',
      body: data,
    }),
  // 获取登录人信息
  getStaffUserInfo: data =>
    request(`/core/sm/getEmpInfoByType?emp_id=${data.emp_id}&type=${data.type}`, {
      method: 'get',
    }),
  // 邮件获取临时token
  getEmailToken: data =>
    request('/oauth2/oauth/getToken/email', {
      method: 'post',
      body: data,
    }),
  verifySalary: data =>
    request('/core/salary/preCheckMyEncrypt', {
      method: 'get',
      headers: {
        menu_id: data,
      },
    }),
  // 记录路由
  recordingRoute: data =>
    request(`/oauth2/log/addNewLog?route=${data}`, {
      method: 'post',
    }),
  // 日志
  recordingLog: () =>
    fetch(`${process.env.VUE_APP_REQUEST_BASE_URL}/oauth2/log/login`, {
      method: 'get',
    }),
  //微信扫码登录
  noSecretWechat: data =>
    request(`/oauth2/wechat/saomaLogin/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //企业微信登录
  noSecretWeix: data =>
    request(`/oauth2/loginWeix/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //钉钉登录
  noSecret: data =>
    request(`/oauth2/loginDing/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //飞书登录
  noSecretFeis: data =>
    request(`/oauth2/loginFeiShu/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //飞书扫码登录
  scanCodeFeis: data =>
    request(`/oauth2/feishu/saomaLogin/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  // 获取token(招聘)
  getrecruitToken: () =>
    request(`/core/recruit/token`, {
      method: 'get',
    }),
  // 获取需要跳转的网址(招聘)
  getrecruitUrl: data =>
    request(`/core/recruit/login/backstage`, {
      method: 'get',
      headers: {
        authorization: data.auth,
      },
      params: { userKey: data.key },
    }),

  // 获取需要跳转的网址(魔学院)
  getmoboUrl: data =>
    request(`/core/recruit/mobo/sso/pc`, {
      method: 'get',
    }),
  // 获取对接的第三方应用
  queryTpcode: data =>
    request(`/oauth2/oauth/query/tpcode`, {
      method: 'get',
    }),
  // 访客获取临时token
  visitorToken: data =>
    request(`/oauth2/ob/visitor/access/token`, {
      method: 'post',
      body: data,
    }),
};
